export default __webpack_public_path__ + "static/media/3.97a50921.jpg";